<template>
	<div class="container">
		<div v-if="data.show_title">
			<h3>{{ data.title }}</h3>
		</div>
		<div class="row">
			<div class="col-12 col-md-6 col-lg-4 py-3" v-for="(item, index) in ItemQuantity ?? []">
				<news-card-image-top v-if="newsType === NewsTypeEnum.BIG_VERTICAL" :news="item"/>
				<news-card-big-image v-else-if="newsType === NewsTypeEnum.SMALL" :news="item"/>
				<news-card-horizontal v-else-if="newsType === NewsTypeEnum.BIG_HORIZONTAL" :news="item"/>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-auto">
				<button-unit
						:options="{
							text: this.translate('news-more'),
							shape: this.buttonShape,
							bgColor: this.buttonBgColor,
							textColor: this.buttonTextColor
						}"
						@click-on-btn="$router.push({name: 'news'})"
				/>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {PageComponentClass, PageComponentInterface} from "../Interfaces/PageComponentInterface";
import {NewsTypeEnum} from "../Enums/NewsTypeEnum";
import NewsCardImageTop from "../../../Components/NewsComponents/NewsCardImageTop.vue";
import NewsCardBigImage from "../../../Components/NewsComponents/NewsCardBigImage.vue";
import NewsCardHorizontal from "../../../Components/NewsComponents/NewsCardHorizontal.vue";
import {ButtonUnitShape} from "../../../Components/Units/Interfaces/ButtonUnitShape";
import ButtonUnit from "../../../Components/Units/ButtonUnit.vue";

export default defineComponent({
	name: "NewsPageSection",
	components: {
		NewsCardImageTop,
		NewsCardBigImage,
		NewsCardHorizontal,
		ButtonUnit
	},
	props: {
		data: {
			type: Object as PropType<PageComponentInterface>,
			default: new PageComponentClass(),
			required: true,
		}
	},
	computed: {
		NewsTypeEnum() {
			return NewsTypeEnum
		},
		newsType() {
			return this.data.data.type ? parseInt(this.data.data.type) : NewsTypeEnum.BIG_VERTICAL;
		},
		ItemQuantity() {
			const {data: {news, quantity}} = this.data
			return (news ?? []).slice(0, quantity);
		},
		buttonShape(): string | ButtonUnitShape {
			return ButtonUnitShape.ROUNDED
		},
		buttonBgColor(): string {
			return '#373B41';
		},
		buttonTextColor(): string {
			return '#fff';
		},
	}
});
</script>

<style scoped>
</style>
